import DeliveryDateSelector from '@/components/deal/delivery-date/delivery-date-selector';
import { FinanceManagerSelector } from '@/components/deal/finance-manager/finance-manager-selector';
import { DealPrioritySelectorButton } from '@/components/deal/priority/deal-priority-selector-button';
import { SalesRepSelectors } from '@/components/deal/sales-reps/sales-reps-selectors';
import { DealStatusSelector } from '@/components/deal/status/deal-status-selector';
import TasksFraction from '@/components/deal/tasks/tasks-fraction';
import TasksProgressRing from '@/components/deal/tasks/tasks-progress-ring';
import { Card } from '@/components/ui/card';
import { DealRapidReconAlertBadge } from '@/components/ui/deal-rapid-recon-alert-badge';
import { DealTimeStatusBadge } from '@/components/ui/deal-time-status-badge';
import { DealUserEngagedBadge } from '@/components/ui/deal-user-engaged-badge';
import useGoToDeal from '@/hooks/use-go-to-deal';
import type { DealListItem } from '@/models/types';
import { isEmpty } from 'lodash';

const DealCard = ({ deal }: { deal: DealListItem }) => {
  const assignedTasks = deal.assigned_tasks || [];

  const { goToDeal } = useGoToDeal();

  return (
    <div className="w-96">
      <Card>
        <a
          // UX NOTE: This need to be a link otherwise cmd+click to open in new tab
          // will not work, and that's important for user's workflow
          className="flex flex-row items-center gap-2 px-4 py-2 hover:bg-gray-100 justify-between"
          onClick={() => {
            goToDeal({
              dealShortId: deal.short_id,
              isForInbox: false,
            });
          }}
          // TODO (jimmy): make this a informative link
          // href={`/${hubPathIdentifier}/deal/${deal.short_id}`}
        >
          <div className="flex flex-col items-center gap-2 w-full">
            <div className="flex flex-row items-start gap-2 justify-between w-full">
              <div className="flex flex-col justify-start gap-1">
                <div className="">{deal.short_id}</div>
                <div className="flex flex-row items-center gap-2">
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    className="flex"
                  >
                    <DealStatusSelector
                      id={deal.id}
                      shortId={deal.short_id}
                      value={deal.status}
                      hideCopy
                      side="right"
                    />
                  </div>

                  <div className="text-nowrap overflow-hidden text-ellipsis">
                    {deal.customer_name}
                  </div>
                </div>
              </div>

              <div
                className="flex flex-col items-center gap-0 text-nowrap overflow-hidden text-ellipsis justify-end"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <div className="flex flex-row items-center w-full justify-end">
                  <FinanceManagerSelector
                    id={deal.id}
                    value={deal.finance_manager}
                    hideName
                  />
                </div>
                <div className="flex flex-row items-center w-full justify-end">
                  {deal.vehicle && (
                    <SalesRepSelectors
                      dealShortId={deal.short_id}
                      dealId={deal.id}
                      hideCopy
                      orientation="horizontal"
                      primarySalesRep={deal.primary_sales_rep}
                      secondarySalesRep={deal.secondary_sales_rep}
                      vehicle={deal.vehicle}
                      primaryCustomerFullName={deal.customer_name}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-row items-center gap-2 justify-start w-full">
              {deal.delivery_date && (
                <div
                  className="flex flex-row items-center border rounded-md"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <DeliveryDateSelector
                    delivery_date={deal.delivery_date}
                    dealId={deal.id}
                    hideIcon
                    hideYear
                    dateClassName="text-xs "
                    side="bottom"
                  />
                </div>
              )}
              {!isEmpty(assignedTasks) && (
                <div className="flex flex-row items-center gap-1 p-1 border rounded-md">
                  <TasksProgressRing assignedTasks={assignedTasks} />
                  <TasksFraction
                    assignedTasks={assignedTasks}
                    className="gap-0 text-xs "
                  />
                </div>
              )}
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <DealPrioritySelectorButton
                  id={deal.id}
                  value={deal.priority}
                  hideCopy
                  side="right"
                />
              </div>
              <DealTimeStatusBadge
                status={deal.status}
                dateString={deal.created_at}
                className="w-fit"
                hideCopy
              />
              <DealRapidReconAlertBadge dealId={deal.id} size="compact" />
              <DealUserEngagedBadge dealId={deal.id} size="compact" />
            </div>
          </div>
        </a>
      </Card>
    </div>
  );
};

export default DealCard;
